import { useLayoutEffect, useRef, useState } from "react";

export function useStepWizard<T extends readonly string[]>(
  currentStep: T[number],
  steps: T,
) {
  const previousStepRef = useRef(currentStep);
  const stepsRef = useRef(steps);
  stepsRef.current = steps;
  const [direction, setDirection] = useState<"left" | "right">("left");
  useLayoutEffect(() => {
    const newDirection =
      stepsRef.current.indexOf(currentStep) <
      stepsRef.current.indexOf(previousStepRef.current)
        ? "right"
        : "left";
    setDirection(newDirection);
    previousStepRef.current = currentStep;
  }, [currentStep]);

  function containerProps(step: T[number]) {
    return { direction, show: step === currentStep };
  }
  return { direction, containerProps };
}
